import type { Theme } from "@emotion/react";
import { css } from "@emotion/react";

import { layers } from "@styles";

export const mobileNavheight = "4.5rem";

export const wrapper = css`
  height: ${mobileNavheight};
`;

export const fixedMobileTopBar = (theme: Theme) => css`
  border-bottom: 1px solid ${theme.separator.base};
  background-color: ${theme.surface.level1};
  height: ${mobileNavheight};
  width: 100%;
  position: fixed;
  z-index: ${layers.indexStickyNavBar};
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const container = css`
  position: relative;
`;

export const logoIcon = css`
  svg {
    height: 1.5rem;
  }
  position: absolute;
  top: 4px;
  left: 50%;
  transform: translateX(-50%);
`;
